import { Zap } from "lucide-react";
import { COMPANY, NAV } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050B14] border-t border-white/10 pt-16 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-10 w-10 border border-[#FF5A00] font-serif-display font-bold relative overflow-hidden">
                <span className="relative z-10">JP</span>
                <Zap className="absolute -bottom-2 -right-1 h-4 w-4 text-[#FF5A00] opacity-70" />
              </span>
              <span className="font-serif-display text-xl">{COMPANY.legal}</span>
            </div>
            <p className="mt-6 font-mono-tech text-sm text-[#94A3B8] max-w-sm leading-relaxed">
              {COMPANY.tagline}. Powering offshore platforms, wind farms and marine vessels
              to international maritime safety standards.
            </p>
          </div>

          <div className="lg:col-span-3">
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#FF5A00]">
              Navigate
            </span>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <button
                    onClick={() => go(n.href)}
                    className="font-mono-tech text-sm text-[#94A3B8] hover:text-[#F8FAFC] transition-colors"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#FF5A00]">
              Contact
            </span>
            <ul className="mt-5 space-y-3 font-mono-tech text-sm text-[#94A3B8]">
              <li>
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#F8FAFC] transition-colors">
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-[#F8FAFC] transition-colors">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="max-w-xs leading-relaxed">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono-tech text-xs text-[#5b6b80]">
            © {year} {COMPANY.legal}. All rights reserved.
          </p>
          <p className="font-mono-tech text-xs text-[#5b6b80]">{COMPANY.reg}</p>
        </div>
      </div>
    </footer>
  );
}
